import React from 'react';
import { useSelector } from 'react-redux';

import DrawTools from './draw-tools';
import Loader from '../loader';

import { RootState } from '../../../reducers/app';

import './audit-area.scss';
/**
 * Component enabling a user to select an Audit area
 */

const AuditArea = () => {
  // LOCAL STATE

  // REDUX
  const loaderActive = useSelector((state: RootState) => state.leftpanel.loader);

  return (
    <div>
      {loaderActive && <Loader />}
      <p className='left-panel__description'>
        Select an FSC Certified Forest from the map, draw, or upload your own Area of Interest. AOIs can be uploaded as
        a zipped shapefile (containing all component files), KML, or KMZ
      </p>
      <DrawTools dataType={'audit'} />
      
    </div>
  );
};

export default AuditArea;
